module.exports = "/assets/js/5ee7fc4ba1fe23bda14b611f59034a46.svg";